import { render, staticRenderFns } from "./controlPanel.vue?vue&type=template&id=22319450&scoped=true&"
import script from "./controlPanel.vue?vue&type=script&lang=js&"
export * from "./controlPanel.vue?vue&type=script&lang=js&"
import style0 from "./controlPanel.vue?vue&type=style&index=0&id=22319450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22319450",
  null
  
)

export default component.exports